module.exports = __webpack_public_path__ + "img/twitter.7e701224.png";